import { DateTypeFilter } from '@gripp/shared-logic';

export const getDateFilter = (dateFilter?: {
  dateType: DateTypeFilter;
  startDate?: string;
  endDate?: string;
}) => {
  if (!dateFilter || dateFilter.dateType === DateTypeFilter.ALL) {
    return {};
  }

  if (dateFilter.dateType === DateTypeFilter.CUSTOMDATE) {
    const filter: any = {};
    if (dateFilter.startDate) {
      // Convert date string to ISO format
      const startDate = new Date(dateFilter.startDate);
      filter.startDate = startDate.toISOString();
    }
    if (dateFilter.endDate) {
      // Convert date string to ISO format and set to end of day
      const endDate = new Date(dateFilter.endDate);
      endDate.setHours(23, 59, 59, 999); // Set to end of day
      filter.endDate = endDate.toISOString();
    }
    return filter;
  }

  // For predefined date ranges, we need to calculate the date range
  const now = new Date();
  let startDate: Date;
  const endDate: Date = now;

  switch (dateFilter.dateType) {
    case DateTypeFilter.TODAY:
      startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      break;
    case DateTypeFilter.THISWEEK:
      const dayOfWeek = now.getDay();
      const diff = now.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
      startDate = new Date(now.getFullYear(), now.getMonth(), diff);
      break;
    case DateTypeFilter.THISMONTH:
      startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      break;
    default:
      return {};
  }

  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };
};
